import { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { endPoints, getData } from "../utilities/networkCalls";
import { AppConfigContext } from "../context/AppConfigContext";
import { Banner, Button, Link } from "@shopify/polaris";
import { BiLinkExternal } from "react-icons/bi";
import useBundleMixpanelHook from "../hooks/useBundleMixpanelHook";
let mounted = false;
typeof mounted;
const states = {
    enabled: 1,
    disabled: 0,
    loading: -1,
};
function EnableExtensionModal({
    setCanShowExpiry,
    appType = "Bundles",
}: {
    setCanShowExpiry: Dispatch<SetStateAction<boolean | null>> | null;
    appType?: string;
}) {
    const [isEnabled, setIsEnabled] = useState(states.loading);
    const appConfigContext = useContext(AppConfigContext);
    const { trackEnableCoreSnippet } = useBundleMixpanelHook();
    const extensionUrl = `https://admin.shopify.com/store/${appConfigContext.shop}/themes/current/editor?context=apps&activateAppId=${appConfigContext.extensionId}%2Fkefi`;
    useEffect(() => {
        const checkExtension = async () => {
            if (document.visibilityState === "visible") {
                shopify.loading(true);
                const res = await getData({ url: endPoints.extensionStatus });
                shopify.loading(false);
                if (res.status === 200) {
                    if (res.data.status === 1) {
                        setCanShowExpiry && setCanShowExpiry(true);
                        setIsEnabled(states.enabled);
                    } else {
                        setCanShowExpiry && setCanShowExpiry(false);
                        setIsEnabled(states.disabled);
                    }
                } else {
                    setIsEnabled(states.disabled);
                }
            }
        };
        checkExtension();
        document.addEventListener("visibilitychange", checkExtension);

        return () => {
            document.removeEventListener("visibilitychange", checkExtension);
            mounted = true;
        };
    }, []);

    return isEnabled === states.disabled ? (
        <>
            <Banner title="Action Required" tone="warning">
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 10,
                    }}
                >
                    {appType || "Bundles"} will only be displayed once you Enable Kefi Core Snippet.
                    <Link
                        onClick={() => {
                            trackEnableCoreSnippet({
                                cta: "Enable Core Snippet",
                                ctaType: "Banner Card",
                            });
                        }}
                        url={extensionUrl}
                        target="_blank"
                    >
                        <Button
                            variant="primary"
                            icon={<BiLinkExternal size="16px" style={{ marginBottom: "-3px" }} />}
                        >
                            Enable Core Snippet
                        </Button>
                    </Link>
                </div>
            </Banner>
        </>
    ) : (
        ""
    );
}

export default EnableExtensionModal;
